import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import userStore from '../../store/userStore';
import CostsSummary from './CostsSummary';
import CostsByChannel from './CostsByChannel';
import CostsSimulator from './CostsSimulator';
import CostRates from './CostRates';
import { currentMonth } from './costsFormat';

/**
 * Costes de proveedores, fase 1 (solo admin). Plan: docs/costes-plan.md.
 *
 * Cuánto se gasta en cada proveedor (estimado contra factura), cuánto cuesta
 * cada acción y por resultado, y el simulador de volumen de llamadas. El coste
 * se calcula al leer, con la tarifa vigente el día de cada evento.
 */
const TABS = [
  { key: 'summary', label: 'Resumen' },
  { key: 'channels', label: 'Por canal' },
  { key: 'simulator', label: 'Simulador' },
  { key: 'rates', label: 'Tarifas' },
];

const CostsPage = () => {
  const user = userStore(state => state.user);
  const [tab, setTab] = useState('summary');
  const [month, setMonth] = useState(currentMonth());

  if (user?.role !== 'admin') return <Navigate to='/dashboard' replace />;

  return (
    <MainLayout>
      <div className='space-y-4'>
        <header className='bg-white border border-slate-200 rounded-lg px-5 py-4 flex flex-wrap items-end justify-between gap-3'>
          <div>
            <h1 className='text-2xl font-semibold text-slate-900'>Costes</h1>
            <p className='text-sm text-slate-500'>Lo que se gasta en cada proveedor y lo que cuesta cada acción. La factura manda; el resto es estimado.</p>
          </div>
          {tab !== 'simulator' && (
            <label className='text-sm text-slate-600'>
              Mes
              <input
                type='month'
                value={month}
                max={currentMonth()}
                onChange={e => e.target.value && setMonth(e.target.value)}
                className='block mt-1 border border-slate-300 rounded-lg px-3 py-1.5'
              />
            </label>
          )}
        </header>

        <nav className='flex gap-1 border-b border-slate-200' role='tablist'>
          {TABS.map(t => (
            <button
              key={t.key}
              type='button'
              role='tab'
              aria-selected={tab === t.key}
              onClick={() => setTab(t.key)}
              className={`px-4 py-2 text-sm -mb-px border-b-2 ${tab === t.key ? 'border-indigo-600 text-indigo-700 font-medium' : 'border-transparent text-slate-500 hover:text-slate-700'}`}
            >
              {t.label}
            </button>
          ))}
        </nav>

        {tab === 'summary' && <CostsSummary month={month} onGoToRates={() => setTab('rates')} />}
        {tab === 'channels' && <CostsByChannel month={month} />}
        {tab === 'simulator' && <CostsSimulator />}
        {tab === 'rates' && <CostRates month={month} />}
      </div>
    </MainLayout>
  );
};

export default CostsPage;
